const list = {
    getUserDetail: 'User/getUserDetail', //获取登录人个人信息
    changPassword: 'auth/editPassword', //修改密码
    delUser: 'User/del_user',
    addUser: 'User/add_user',
    editUser: 'User/mod_user',
};

export default list;